module.exports = __webpack_public_path__ + "media/wo_de_dianhua_haoma_shi2.7193b3a3.mp3";